import React from 'react';

import { CommonHead } from '@app/components/CommonHead';
import { Footer } from '@app/components/Footer';
import Header from '@app/components/home/Header';

interface SimpleLayoutProps {
  children: React.ReactNode;
}

const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children }) => {
  return (
    <>
      <CommonHead />

      <div className="min-h-screen bg-gray-50 flex flex-col text-gray-900">
        <Header showFull={false} enableBackButton />
        {/* Main Content */}
        <main className="flex flex-col grow-1 items-center justify-center border-t border-gray-200">
          {children}
        </main>

        <Footer showFull={false} />
      </div>
    </>
  );
};

export default SimpleLayout;
